import React from "react";
import { FEATURE_COMING_SOON_MESSAGE } from "../../common/apiResponse";

const FeatureComingSoon = ({
  message = FEATURE_COMING_SOON_MESSAGE,
}) => (
  <div className="feature-coming-soon">{message}</div>
);

export default FeatureComingSoon;
